export default "__VITE_ASSET___z$wq5Op__"